import VerifyEmail from "./VerifyEmail.component";

export default VerifyEmail;
